import React,{useContext, useEffect, useState} from 'react';
import MainMenu from './../../../components/mainMenu/MainMenu';
import LeftSitebarMenu from './../../../components/leftSitebarMenu/LeftSitebarMenu';
import RightSitebarMenu from './../../../components/rightSitebarMenu/RightSitebarMenu';
import closerIcon from '../../../assets/img/feed-imgs/navbar/closeicon.svg';
import clipPlayIcon from '../../../assets/img/clips-imgs/clips-play.svg';
import smilingImage from '../../../assets/img/clips-imgs/clip-smallplay.svg';
import clipsStar from '../../../assets/img/clips-details-imgs/clips-star.svg';
import { ShowHideSitebar } from './../../../App';
import { clipsSingleData as clipsSingleDataApi } from '../../../api';
import { useParams } from 'react-router-dom';
import './ClipsDetails.css';
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Pagination } from 'swiper';
import { SwiperSlide , Swiper} from 'swiper/react';

const ClipsDetails = () => {
    const [ clipsDetailsData, setClipsDetailsData ] = useState([])
    const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
    useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'blogs';
        setPageName.blogs.left = false;
        setPageName.blogs.right = false;
        setShowHideSidebar(setPageName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const closeSidebar =(whichSidebar, status)=>{
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus.blogs.left = status /** changing the page name for left sidebar to toggle */
            setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
        }
        if(whichSidebar === 'right'){
            newStatus.blogs.right = status
            setShowHideSidebar(newStatus)
        }
    }
    // Clips Details Fetch Data 
    const paramsId = useParams()
    useEffect( ()=>{
        clipsSingleDataApi().then( data => setClipsDetailsData(data[Number(paramsId.id)] ))
    },[paramsId?.id])
    console.log('FInal Data', clipsDetailsData, clipsDetailsData.id)
    const restItem = localStorage.getItem(0)
    const cardItemAdd = () =>{
        localStorage.setItem( "cardItem" , restItem + 1 )
    }
    const [ showPlayVideoButton, setShowPlayVideoButton ] = useState(true)
   const myVideoId = document.getElementById('myVideo');
//    console.log(myVideoId.timeupdate)
   const videoPauseButton = () =>{
        myVideoId.pause()
        setShowPlayVideoButton(true)
   }
   const buttonStatus = () =>{
    myVideoId.play()
    setShowPlayVideoButton(false)
   }
    const [ changeVolumeIcon , setChangeVolumeIcon ] = useState(true)
    const volumeField = e =>{
        myVideoId.volume = e.target.value;
        console.log(e.target.value)
        if(myVideoId.volume === 0 ){
            setChangeVolumeIcon(!changeVolumeIcon)
        }
    }
    const [ videoTimeCalculation, setVideoTimeCalculation ] = useState(0 + 0)
    const [ convertedMinit, setConvertedMinit] = useState(0 + 0)
    const videoTimeAction = e =>{
    
        let currentMinites = Math.floor( e / 60 )
        let currentSecond = e.toFixed(2)
        // let finalSecondResult = Math.floor(currentSecond - 60 )
        // console.log(currentMinites,finalSecondResult /60 )
        // let currentSeconds = Math.floor(  currentMinites - currentMinites * 60 )
        if( currentMinites < 10 ){
            setVideoTimeCalculation("0"+ currentMinites )
        }
        
        // let currentSeconds = e.toFixed(2)
        // let convertNumber = 60 - currentSeconds  
        // setConvertedMinit(convertNumber )
        if( Math.floor(currentSecond) > 60){
            setConvertedMinit(Math.floor(currentSecond) -60 )
        }else{
            if(  Math.floor(currentSecond) <10 ){
                setConvertedMinit( "0" + Math.floor(currentSecond))
            }
            else{
                 setConvertedMinit(Math.floor(currentSecond) )
            }
        }
    }
    // console.log(convertedMinit)
    const [ videoPlayNumber , setVideoPlayNumber ] = useState(1)
    const thumbnailIdentifyNumber  = index =>{
        setVideoPlayNumber(index)
    }
    return (
        <div>
            <MainMenu></MainMenu>
            {/* Menu bar start here */}
            <div className="container-fluid container-xxl">
                <div className="row gap-5 gap-lg-0">
                    {/* Left Site Bar Start here */}
                    <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.blogs?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                        <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <LeftSitebarMenu></LeftSitebarMenu>
                    </div>    
                    {/* left Site Bar End Hre */}

                    {/* Center Align Items Code start Here*/}
                    <div className="col-12 col-lg-10">
                        <div className="row mb-5 gap-3 gap-lg-0">
                            {/* <div className="col-12 col-lg-7 position-relative">
                                <div className="row mb-3">
                                    <div className="col position-relative">
                                        <video src={testVideo} className="w-100 d-block cursor-pointer" height="100%" style={{borderRadius: "30px"}} id="myVideo" onClick={videoPauseButton} poster={smilingOne}> </video>
                                        <div className={ showPlayVideoButton ? `d-block position-absolute c_play cursor-pointer`: `d-none` } onClick={buttonStatus} >
                                            <img src={clipPlayIcon} alt=''/>    
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4">
                                        <img className="w-100 image-redius" src={smilingTwo}  alt='' />
                                    </div>
                                    <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4">
                                        <div className="position-relative">
                                            <img className="w-100" src={smilingOne} style={{borderRadius: "20px", border: "4px solid #B402F6" }} alt='' />
                                            <div className="position-absolute c_play">
                                                <img src={smilingImage} alt='' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4">
                                        <img className="w-100 image-redius" src={smilingThree}  alt='' />
                                    </div>
                                    <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4"></div>
                                </div>
                            </div> */}
                            <div className="col-12 col-lg-7 position-relative  d-none d-sm-block">
                                <div className="row mb-3">
                                    <div className="col position-relative">
                                        {/* Play Video Are here */}
                                        {
                                            console.log(clipsDetailsData?.videoRelatedInfo?.[videoPlayNumber],"137 No line Bro")
                                        }
                                        <video src={clipsDetailsData?.realVideoUrl?.[videoPlayNumber]} className="w-100 d-block cursor-pointer" height="100%" style={{borderRadius: "30px"}} id="myVideo" onClick={videoPauseButton} poster={clipsDetailsData?.videoRelatedInfo?.[videoPlayNumber]} onTimeUpdate={e =>videoTimeAction(e.target.currentTime)}> </video>
                                        {/* Vidoe All Control parts Are here */}
                                        <div className='d-flex sound-control justify-content-between align-items-center w-100 px-5'>
                                           <div className='d-flex justify-content-center align-items-center'>
                                                <i className={  showPlayVideoButton ?  `d-none `:  `d-block fa-solid fa-pause me-3 videoControlButtons cursor-pointer`}onClick={videoPauseButton}  ></i>
                                                <i className={  showPlayVideoButton ?  `d-block fa-solid fa-play me-3 videoControlButtons cursor-pointer`:  `d-none`}onClick={buttonStatus}  ></i>                                            
                                                <i className={changeVolumeIcon ? `d-none `: `d-block fa-solid fa-volume-xmark videoControlButtons cursor-pointer me-2`}></i>
                                                <i className={changeVolumeIcon ? `d-block fa-solid fa-volume-low videoControlButtons cursor-pointer me-2`: `d-none`}></i>
                                                <input type="range" min="0" max="1" step="0.01" className="cursor-pointer rengeUpgrade" onMouseMove={ e => volumeField(e)} />
                                           </div>
                                            <div>
                                                <span className='videoControlButtons'> <span className="current-time">{videoTimeCalculation} : {convertedMinit}</span> / <span className="duration">00:26</span></span>
                                            </div>
                                        </div>
                                        <div className={ showPlayVideoButton ? `d-block position-absolute c_play cursor-pointer`: `d-none` } onClick={buttonStatus} >
                                            <img src={clipPlayIcon} alt=''/>    
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {
                                        clipsDetailsData?.videoRelatedInfo?.map(( item, index ) =><div className=" d-none d-sm-block col-3 d-lg-flex justify-content-start align-items-center gap-4" key={index}>
                                           {
                                               videoPlayNumber === index ? <div className="position-relative  ">
                                             <img className="w-100 image-redius cursor-pointer image-border-design-usingbtn" src={item}  alt='' onClick={ () => thumbnailIdentifyNumber(index)}/>
                                               <div className="position-absolute c_play cursor-pointer">
                                                   <img src={smilingImage} alt='' />
                                               </div>
                                           </div> : <img className="w-100 image-redius cursor-pointer" src={item}  alt='' onClick={ () => thumbnailIdentifyNumber(index)}/>
                                           }
                                             
                                    </div> )
                                    }
                                    {/* <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4">
                                        <img className="w-100 image-redius" src={smilingTwo}  alt='' />
                                    </div> */}
                                    {/* <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4">
                                        <div className="position-relative">
                                            <img className="w-100" src={smilingOne} style={{borderRadius: "20px", border: "4px solid #B402F6" }} alt='' />
                                            <div className="position-absolute c_play">
                                                <img src={smilingImage} alt='' />
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4">
                                        <img className="w-100 image-redius" src={smilingThree}  alt='' />
                                    </div> */}
                                    {/* <div className="col-3 d-lg-flex justify-content-start align-items-center gap-4"></div> */}
                                </div>
                            </div>
                            <div className='col-12 position-relative  d-block d-sm-none d-lg-none d-xxl-none d-md-none'>
                                {/* <video src={item} controls width="100%" height="250px" style={{display:"none"}}></video>
                                    <span><i className="fa-solid fa-circle-dot" style={{display:"inline"}} >{console.log(index)}</i></span> */}

                                    <Swiper
                                        spaceBetween={30}
                                        pagination={{
                                        clickable: true,
                                        }}
                                        modules={[Navigation,Pagination]}
                                        className="mySwiper"
                                    >
                                            {
                                            clipsDetailsData?.realVideoUrl?.map((item, index) => <SwiperSlide key={index}><video src={item} controls width="100%" height="auto"></video></SwiperSlide>)
                                        }

                                    </Swiper>
                            </div>
                            <div className="col-12 col-lg-5">

                                <div className="row gap-3 mb-4 my-xm-5">
                                    <div className="col-12">
                                          {/* Tages Map */}
                                          {clipsDetailsData?.tags?.map(( item, index ) =><div className="rounded-pill d-inline-flex justify-content-center align-items-center bd_tags me-2" key={index}>
                                        <span className="txt_wa">{item} </span>
                                        </div>  )}
                                        
                                    </div>
                                    <div className="col-12">
                                        <h1 className="mb-0 fr_h">
                                            {clipsDetailsData?.clipTitle}
                                        </h1>
                                    </div>
                                    <div className="col-12 d-flex justify-content-start align-items-center gap-2">
                                        <div className="rounded-pill px-2 py-1 d-flex justify-content-center align-items-center gap-1" style={{height: "30px",border: "3px solid #B402F6"}}>
                                            <img src={clipsStar} alt='' />
                                                <span className="txt_name">{clipsDetailsData?.avarageRating}<br /></span>
                                        </div>
                                        <div className="d-flex justify-content-start align-items-center gap-4">
                                            <span className="cd_rating">{clipsDetailsData?.ratingPeople} ratings</span>
                                            <span className="text-color">|</span>
                                            <div className="d-flex justify-content-start align-items-center gap-2">
                                                <img className="rounded-circle d-flex gap-4" src={clipsDetailsData?.authorIcon} alt='' />
                                                <span className="txt_wa d-flex gap-4">{clipsDetailsData.authName}</span></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row gap-4 mb-4">
                                    <div className="col-12">
                                        <div className="row gy-2">
                                            <div className="col-12 col-xxl-5 d-flex">
                                                <span className="fr_total">Length : </span>
                                                <span className="txt_wa">&nbsp;{clipsDetailsData?.lengthOfVideo}<br /></span>
                                            </div>
                                            <div className="col-12 col-xxl-5 d-flex ps-xxl-0">
                                                <span className="fr_total">Format : </span>
                                                <span className="txt_wa">&nbsp;{clipsDetailsData?.videoFormat}<br /></span>
                                            </div>
                                            <div className="col-12 col-xxl-5 d-flex">
                                                <span className="fr_total">Size : </span>
                                                <span className="txt_wa">&nbsp;{clipsDetailsData?.videoSize}<br /></span>
                                            </div>
                                            <div className="col-12 col-xxl-5 d-flex ps-xxl-0">
                                                <span className="fr_total">Resolution : </span>
                                                <span className="txt_wa">&nbsp;{clipsDetailsData?.resolution}<br /></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-4">
                                    <div className="col-12">
                                        <div>
                                            <span className="cd_sf">Starting from</span>
                                        </div>
                                        <span className="cd_money">${clipsDetailsData?.startingRate}</span>
                                    </div>
                                </div>

                                <div className="row gap-2">
                                    <div className="col-12">
                                        <button className="custm-pill-button-small w-100 rounded-pill cd_btn" type="button">Select Options</button>
                                    </div>
                                    <div className="col">
                                        <button className="btn btn-primary w-100 rounded-pill cd_adcbtn" type="button" style={{height: "60px",border: "3px solid #9E9E9E",color: "#9E9E9E",fontWeight: "400",fontSize: "18px",background: "none",fontFamily: "Roboto, sans-serif"}} onClick={cardItemAdd}>Add to Cart</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    
                    {/* Center Align Items Code start Here*/}
                    <div className={`col-12 col-lg-4  d-none-lg ${showHideSidebar?.blogs?.right ? 'd-blog right-sitebarmenu' : 'd-none'}`}>
                    <div className="d-flex d-lg-none justify-content-end my-2">
                        <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <RightSitebarMenu />
                    </div>          
                </div>
            </div>
        </div>
    );
};

export default ClipsDetails;